import nanobus from "../../../nanobus";
import bus from "../../../bus";
import { FLASH } from "../../../action-types";
import { PlayableItemEventName, playerEvents } from "../../events";
// @ts-ignore-next-line
import debounce from "lodash.debounce";

export type ItemProps = {
  item: any,
};

export default abstract class PlayableItem<Props extends ItemProps> {
  _bus = nanobus();
  abstract props: Props;

  constructor(props: Props) {
    this.onError = debounce(this.onError.bind(this), 250);
    this.getCurrentTime = this.getCurrentTime.bind(this);
    this.onDestroy = this.onDestroy.bind(this);
  }
  set(_: Props) {}
  on() {
    // @ts-ignore-next-line TODO
    this._bus.on.apply(this._bus, arguments);
  }
  removeListener() {
    // @ts-ignore-next-line TODO
    this._bus.removeListener.apply(this._bus, arguments);
  }
  removeAllListeners() {
    // @ts-ignore-next-line TODO
    this._bus.removeAllListeners.apply(this._bus, arguments);
  }
  emit(event: PlayableItemEventName, arg: any) {
    this._bus.emit(event, arg);
  }
  onCreate() {}
  onDestroy() {
    this.removeAllListeners();
  }
  getPlayerItemID() {
    const { item } = this.props;
    return item ? item.playable_id : null;
  }
  getTitle() {
    return null;
  }
  getSubtitle() {
    return null;
  }
  getCanonicalPath() {
    const { item } = this.props;
    return item._copy != null
      ? `${window.location.origin}${item._copy.data.canonical_path}`
      : `${window.location.origin}/player-items/go/${item.player_item_id}`;
  }
  getSharedMomentBaseURL() {
    const { item } = this.props;
    if (item.source_id == null) {
      return null;
    }
    // Ideally this would come through the database directly, but it’s a little
    // awkward so we replicate the logic here since it’s simple
    switch (item.type) {
      case "broadcast_episode":
        return `${window.location.origin}/shared/broadcast-episode/${item.source_id}`;
      case "online_episode":
        return `${window.location.origin}/shared/online-episode/${item.source_id}`;
      case "audio_archive_item":
        return `${window.location.origin}/shared/audio-archive-item/${item.source_id}`;
      case "clip":
        return `${window.location.origin}/shared/segment/${item.source_id}`;
      case "podcast_episode":
        return `${window.location.origin}/shared/podcast-episode/${item.source_id}`;
      default:
        return null;
    }
  }
  getLabel() {
    const { item } = this.props;
    if (item._copy) {
      return "item";
    }
    switch (item.type) {
      case "broadcast_episode":
        return "episode";
      case "online_episode":
        return "episode";
      case "audio_archive_item":
        return "audio archive";
      case "clip":
        return "segment";
      case "podcast_episode":
        return "podcast";
      default:
        return "item";
    }
  }
  hasDuration() {
    return true;
  }
  getCurrentTime() {
    return 0;
  }
  getStartTime() {
    return 0;
  }
  getEndTime() {
    return this.getStartTime() - this.getDuration();
  }
  getDuration() {
    return 0;
  }
  tick() {
    bus.emit(playerEvents.TICK);
  }
  isReady() {
    return true;
  }
  isLive() {
    return false;
  }
  canToggleQuality() {
    return false;
  }
  onError() {
    bus.emit(FLASH, {
      type: "alert",
      message: `There was an error playing ‘${this.getTitle()}’.`
    });
    // Set player to default nothing state
    bus.emit(playerEvents.SET, {
      status: "stopped",
      target: {}
    });
  }
  key() {
    return null;
  }
  abstractRender() {
    bus.emit(playerEvents.RENDER, {
      key: this.key(),
      onCreate: this.onCreate,
      onDestroy: this.onDestroy,
      ...this.render()
    });
    return null;
  }
  render() {
    return {
      title: this.getTitle(),
      sourceURL:
        "data:audio/mp3;base64,SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU2LjM2LjEwMAAAAAAAAAAAAAAA//OEAAAAAAAAAAAAAAAAAAAAAAAASW5mbwAAAA8AAAAEAAABIADAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV6urq6urq6urq6urq6urq6urq6urq6urq6v////////////////////////////////8AAAAATGF2YzU2LjQxAAAAAAAAAAAAAAAAJAAAAAAAAAAAASDs90hvAAAAAAAAAAAAAAAAAAAA//MUZAAAAAGkAAAAAAAAA0gAAAAATEFN//MUZAMAAAGkAAAAAAAAA0gAAAAARTMu//MUZAYAAAGkAAAAAAAAA0gAAAAAOTku//MUZAkAAAGkAAAAAAAAA0gAAAAANVVV"
    };
  }
}
